import { render, staticRenderFns } from "./NewsSquare.vue?vue&type=template&id=37f74886&"
import script from "./NewsSquare.vue?vue&type=script&setup=true&lang=js&"
export * from "./NewsSquare.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports